import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _currentUser = {};

let AuthStore = assign({}, EventEmitter.prototype, {
    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getCurrentUser: function() {
         return _currentUser;
    }
});


AuthStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.AUTH_INFO:
            _currentUser = action.data;
            AuthStore.emitChange();
            break;

        default:
            break;
    }

});

export default AuthStore;
